import * as Api from '@ViewModels';
import casePeerLogo from '../../../assets/logo_8am_casepeer.png';
import bloomerangLogo from '../../../assets/logo_bloomerang.svg';
import clioLogo from '../../../assets/logo_clio.png';
import donorPerfectLogo from '../../../assets/logo_donorperfect.png';
import housecallProLogo from '../../../assets/logo_housecallpro_banner.png';
import medicareProLogo from '../../../assets/logo_medicarepro.png';
import microsoftDynamics365SalesLogo from '../../../assets/logo_microsoft_dynamics_sales_banner.png';
import myCaseLogo from '../../../assets/logo_8am_mycase.png';
import eclipseLogo from '../../../assets/logo_nasasoft.png';
import redtailLogo from '../../../assets/logo_redtail.png';
import salesforceLogo from '../../../assets/logo_salesforce.svg';
import serviceTitanLogo from '../../../assets/logo_servicetitan_banner.png';
import wealthboxLogo from '../../../assets/logo_wealthbox.png';
import practicePantherLogo from '../../../assets/practice-panther-logo.svg';
import qboLogo from '../../../assets/qb-logo-horizontal-preferred.svg';

const integrationProviderLogos: Record<string, string> = {
	[Api.IntegrationProvider.Bloomerang]: bloomerangLogo,
	[Api.IntegrationProvider.CasePeer]: casePeerLogo,
	[Api.IntegrationProvider.Clio]: clioLogo,
	[Api.IntegrationProvider.DonorPerfect]: donorPerfectLogo,
	[Api.IntegrationProvider.Eclipse]: eclipseLogo,
	[Api.IntegrationProvider.HousecallPro]: housecallProLogo,
	[Api.IntegrationProvider.MedicarePro]: medicareProLogo,
	[Api.IntegrationProvider.MicrosoftDynamics365Sales]: microsoftDynamics365SalesLogo,
	[Api.IntegrationProvider.MyCase]: myCaseLogo,
	[Api.IntegrationProvider.PracticePanther]: practicePantherLogo,
	[Api.IntegrationProvider.QuickBooksOnline]: qboLogo,
	[Api.IntegrationProvider.Redtail]: redtailLogo,
	[Api.IntegrationProvider.Salesforce]: salesforceLogo,
	[Api.IntegrationProvider.ServiceTitan]: serviceTitanLogo,
	[Api.IntegrationProvider.Wealthbox]: wealthboxLogo,
};

export const getProviderLogoUrl = (provider: Api.IntegrationProvider) => integrationProviderLogos[provider] ?? '';
